import { render, staticRenderFns } from "./StockItemCard.vue?vue&type=template&id=3214aa5a"
import script from "./StockItemCard.vue?vue&type=script&lang=js"
export * from "./StockItemCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3214aa5a')) {
      api.createRecord('3214aa5a', component.options)
    } else {
      api.reload('3214aa5a', component.options)
    }
    module.hot.accept("./StockItemCard.vue?vue&type=template&id=3214aa5a", function () {
      api.rerender('3214aa5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/StockItemCard.vue"
export default component.exports